var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define('modules/uv-ebookcenterpanel-module/EbookCenterPanel',["require", "exports", "../uv-shared-module/BaseEvents", "../uv-shared-module/CenterPanel", "../../extensions/uv-ebook-extension/Events", "../uv-shared-module/Position"], function (require, exports, BaseEvents_1, CenterPanel_1, Events_1, Position_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var EbookCenterPanel = /** @class */ (function (_super) {
        __extends(EbookCenterPanel, _super);
        function EbookCenterPanel($element) {
            var _this = _super.call(this, $element) || this;
            _this._ebookReaderReady = false;
            _this._state = {};
            _this._prevState = {};
            _this.attributionPosition = Position_1.Position.BOTTOM_RIGHT;
            return _this;
        }
        EbookCenterPanel.prototype.create = function () {
            var _this = this;
            this.setConfig("ebookCenterPanel");
            _super.prototype.create.call(this);
            this._ebookReader = document.createElement("uv-ebook-reader");
            this.$content.prepend(this._ebookReader);
            this._ebookReader.setAttribute("width", "100%");
            this._ebookReader.setAttribute("height", "100%");
            this._ebookReader.addEventListener("loadedNavigation", function (e) {
                _this.component.publish(Events_1.Events.LOADED_NAVIGATION, e.detail);
            }, false);
            this._ebookReader.addEventListener("relocated", function (e) {
                _this.component.publish(Events_1.Events.RELOCATED, e.detail);
                _this._cfi = e.detail.start.cfi;
                _this.component.publish(Events_1.Events.CFI_FRAGMENT_CHANGED, _this._cfi);
            }, false);
            Utils.Async.waitFor(function () {
                return (window.customElements !== undefined);
            }, function () {
                customElements.whenDefined("uv-ebook-reader").then(function () {
                    _this._ebookReaderReady = true;
                });
            });
            var that = this;
            this.component.subscribe(BaseEvents_1.BaseEvents.OPEN_EXTERNAL_RESOURCE, function (e, resources) {
                that.openMedia(resources);
            });
            this.component.subscribe(Events_1.Events.ITEM_CLICKED, function (href) {
                _this._nextState({
                    cfi: href
                });
            });
            this.component.subscribe(Events_1.Events.CFI_FRAGMENT_CHANGED, function (cfi) {
                Utils.Async.waitFor(function () {
                    return _this._ebookReaderReady;
                }, function () {
                    if (cfi !== _this._cfi) {
                        _this._nextState({
                            cfi: cfi
                        });
                    }
                });
            });
        };
        EbookCenterPanel.prototype.openMedia = function (resources) {
            var _this = this;
            this.extension.getExternalResources(resources).then(function () {
                var canvas = _this.extension.helper.getCurrentCanvas();
                var annotations = canvas.getContent();
                if (annotations.length) {
                    var annotation = annotations[0];
                    var body = annotation.getBody();
                    if (body.length) {
                        var media = body[0];
                        //const format: Manifesto.MediaType | null = media.getFormat();
                        _this._nextState({
                            bookPath: media.id
                        });
                    }
                }
                _this.component.publish(BaseEvents_1.BaseEvents.RESIZE);
            });
        };
        EbookCenterPanel.prototype._nextState = function (s) {
            var _this = this;
            this._state = Object.assign({}, this._state, s);
            Utils.Async.waitFor(function () {
                return _this._ebookReaderReady;
            }, function () {
                if (_this._state.bookPath && _this._state.bookPath !== _this._prevState.bookPath) {
                    _this._ebookReader.load(_this._state.bookPath);
                }
                if (_this._state.cfi && _this._state.cfi !== _this._prevState.cfi) {
                    _this._ebookReader.display(_this._state.cfi);
                }
                _this._prevState = Object.assign({}, _this._state);
            });
        };
        EbookCenterPanel.prototype.resize = function () {
            var _this = this;
            _super.prototype.resize.call(this);
            if (this._ebookReaderReady) {
                setTimeout(function () {
                    _this._ebookReader.resize();
                }, 10);
            }
        };
        return EbookCenterPanel;
    }(CenterPanel_1.CenterPanel));
    exports.EbookCenterPanel = EbookCenterPanel;
});

